export default {
  INTERLOCUTORY_APPEAL_REVIEW_APPEAL: 1,
  INTERLOCUTORY_APPEAL_ORDINARY_APPEAL: 2,
  TST_EMBARGOES: 3,
  MAGAZINE_FEATURE: 4,
  EXTRAORDINARY_RESOURCE: 5,
  ORDINARY_RESOURCE: 6,
  TERMINATION_ACTION_APPEAL: 7
}
